<div class="template-selection">
  <p class="subtitle">{{ 'i18n.domain.product-template.publishing-wizard.select-templates' | translate }}</p>
  <div class="templates-grid">
    <div *ngFor="let template of templates" class="template-card" [class.selected]="isSelected(template.templateId)" (click)="openEditDialog(template.templateId)">
      <div class="card-header" (click)="$event.stopPropagation()">
        <img *ngIf="getCurrentImage(template)" [src]="getCurrentImage(template)" alt="Template image" class="template-image">
        <div *ngIf="!getCurrentImage(template)" class="template-image-placeholder">{{ 'i18n.domain.product-template.publishing-wizard.no-image' | translate }}</div>
        <p-button *ngIf="hasMultipleImages(template)" icon="pi pi-chevron-left" [text]="true" severity="secondary" (onClick)="prevImage(template.templateId, $event)" class="nav-button prev-button"></p-button>
        <p-button *ngIf="hasMultipleImages(template)" icon="pi pi-chevron-right" [text]="true" severity="secondary" (onClick)="nextImage(template.templateId, $event)" class="nav-button next-button"></p-button>
        <input type="checkbox" [checked]="isSelected(template.templateId)" (change)="toggleTemplate(template.templateId)" class="template-checkbox">
      </div>
      <div class="card-body">
        <h4>{{ template.templateName }}</h4>
        <div class="template-details">
          <div class="detail-row">
            <label>{{ 'i18n.domain.product-template.publishing-wizard.price' | translate }}: <i class="pi pi-indian-rupee"></i></label>
            <div class="price-control">
              <p-button icon="pi pi-minus" [text]="true" severity="secondary" (onClick)="decreasePrice(template.templateId)"></p-button>
              <input pInputText type="number" [(ngModel)]="getTemplateOverride(template.templateId).price" />
              <p-button icon="pi pi-plus" [text]="true" severity="secondary" (onClick)="increasePrice(template.templateId)"></p-button>
            </div>
          </div>
          <div class="detail-row">
            <label>{{ 'i18n.domain.product-template.publishing-wizard.stock' | translate }}:</label>
            <div class="stock-control">
              <p-button icon="pi pi-minus" [text]="true" severity="secondary" (onClick)="decreaseStock(template.templateId)"></p-button>
              <input pInputText type="text" [value]="getTemplateOverride(template.templateId).quantity" readonly class="stock-input" />
              <p-button icon="pi pi-plus" [text]="true" severity="secondary" (onClick)="increaseStock(template.templateId)"></p-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="selection-summary">
    <div class="seller-profile-selector">
      <label>{{ 'i18n.domain.product-template.publishing-wizard.select-seller-profile' | translate }}<span class="required-mark">*</span>:</label>
      <p-dropdown [options]="sellerProfiles" optionLabel="name" optionValue="id" [(ngModel)]="selectedSellerProfile" placeholder="{{ 'i18n.domain.product-template.publishing-wizard.select-profile' | translate }}"></p-dropdown>
    </div>
    <p>{{ selectedTemplates.size }} {{ 'i18n.domain.product-template.publishing-wizard.templates-selected' | translate }}</p>
    <p-button label="{{ 'i18n.domain.product-template.publishing-wizard.next-configure' | translate }}" icon="pi pi-arrow-right" [disabled]="selectedTemplates.size === 0 || !selectedSellerProfile" (onClick)="proceed()"></p-button>
  </div>
</div>

<app-product-template-edit-dialog
  [visible]="editDialogVisible"
  [template]="selectedTemplateForEdit"
  [form]="editForm"
  [categories]="categories"
  [deliveryOptions]="deliveryOptions"
  [unitTypeOptions]="unitTypeOptions"
  [unitCategoryOptions]="unitCategoryOptions"
  [templateImages]="templateImages"
  [existingImages]="existingImages"
  [removeImageIds]="removeImageIds"
  [setPrimaryImageId]="setPrimaryImageId"
  (visibleChange)="editDialogVisible = $event"
  (save)="saveEditedTemplate()"
  (imageSelected)="onImageSelected($event)"
  (imageRemoved)="removeImage($event)"
  (existingImageRemoved)="removeExistingImage($event)"
  (primaryImageSet)="setPrimaryImage($event)"
  (primaryExistingImageSet)="setPrimaryExistingImage($event)"
  *ngIf="editForm"
></app-product-template-edit-dialog>
